import React from 'react'
import classNames from 'classnames'
import Section from 'src/components/section'
import Picture from 'src/components/picture'
import Slider from 'src/components/slider'
import AspectBox from 'src/components/aspect-box'

const GallerySection = ({
  className,
  title = '',
  body = '',
  children = null,
  images = [],
  reversed = false,
  centeredText = false,
}) => {
  return (
    <Section
      className={classNames(
        'gallery-section',
        reversed && 'reversed',
        centeredText && 'centered-text',
        className
      )}
    >
      <div className="content">
        <div className="copy">
          {title && <h3 className="title">{title}</h3>}
          {body && <h3 className="body">{body}</h3>}
        </div>
        {children && <div className="children">{children}</div>}
      </div>
      <div className={classNames('images', `count-${images.length}`)}>
        <Slider dots autoplay>
          {images.map((image) => (
            <AspectBox key={image.id} className="slider-image" x={324} y={400}>
              <Picture
                defaultWidth={750}
                image={image}
                fitWidth
                fitHeight
                cover
              />
            </AspectBox>
          ))}
        </Slider>
        <div className="gradient" />
      </div>
    </Section>
  )
}

export default GallerySection
